import {createToast} from "../library/utility";
export function initializeToast(options = {}) {
  return (dispatch) => {
      dispatch({ payload: options, type: 'ADD_TOAST' });
  }
}
export function addToast(options = {}) {
  return {
    payload: createToast(options),
    type: "ADD_TOAST"
  };
 
}

export function removeToast(id) {
  return {
    payload: id,
    type: "REMOVE_TOAST"
  };
}
